<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
  <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditationtechnical/planningteam/storeEvaluationPlanification/${evalTest.id}`
            : `/accreditationtechnical/planningteam/storeEvaluationPlanification/`
        "
      >
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Evaluador") }}
          </label>
          <app-input
            class="col-sm-9"
            type="text"
            v-model="evaluatorName"
            :required="true"
            :disabled="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Tipo") }}
          </label>
          <app-input
            class="col-sm-9"
            type="text"
            v-model="inputs.evaluator_type.value"
            :required="true"
            :disabled="true"
          />
        </div>

        <section class="row">
          <legend class="col-sm-12">
            <small class="text-primary">Datos de procedencia</small>
          </legend>
          
        </section>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("SAE o Externo") }}
          </label>
          <app-input
            class="col-sm-9"
            type="text"
            v-model="scope"
            :required="true"
            :disabled="true"
          />
        </div>
        
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Nombre de la entidad donde labora y si es publica o privada") }}
          </label>
          <app-input
            class="col-sm-9"
            type="text"
            v-model="entity"
            :required="true"
            :disabled="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Aplica o no convenio") }}
          </label>
          <app-input
            class="col-sm-9"
            type="radio-buttons"
            v-model="evalTest.is_agreement"
            :list="agreement"
          />
        </div>
        <hr />

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Ciudad  de partida (para compra de pasajes/logística") }}
          </label>
          <app-input
            class="col-sm-9"
            type="text"
            v-model="evalTest.city_start"
            :required="true"
            :placeholder="$t('Ciudad de partida')"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Número total de días") }}
          </label>
          <app-input
            class="col-sm-9"
            type="number"
            v-model="evalTest.number_days"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Fecha de inicio") }}
          </label>
          <app-input
            class="col-sm-9"
            type="date"
            v-model="dateStart"
            :required="true"
            :placeholder="$t('Agregar fecha')"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Fecha de fin") }}
          </label>
          <app-input
            class="col-sm-9"
            type="date"
            v-model="dateEnd"
            :required="true"
            :placeholder="$t('Agregar fecha')"
          />
        </div>


        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Observaciones") }}
          </label>
          <app-input
            class="col-sm-9"
            type="textarea"
            v-model="evalTest.observations"
            :placeholder="$t('Observaciones opcional')"
          />
        </div>
      </form>
    </template>

  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosPost } from '../../../../../../../resources/js/app/helpers/AxiosHelper';

export default {
  name: "DeleteModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    title: String,
    evaluatorData:Object,
    evaluation:Object,
  },
  data() {
    return {
        inputs:{},
        evalTest:{},
        evaluatorName:"",
        dateStart:"",
        dateEnd:"",
        entity:"",
        scope:"",
        modalId: "planification-add-edit-modal",
        agreement:[
          {
            id:0,
            value:"NO"
          },
          {
            id:1,
            value:"Sí"
          },
        ]
    }
    },

  created(){
      this.info();
      this.getData();
  },
  methods: {

    submit(){
      var tmp = {};
      const d = this.dateStart;
      tmp.date_start = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");

      const e = this.dateEnd;
      tmp.date_end = [e.getFullYear(), e.getMonth() + 1, e.getDate()].join("-");

      var request = {};
      request['id'] = this.evalTest.id;
      request["date_start"] = tmp.date_start;
      request["date_end"] = tmp.date_end;
      request["observations"] = this.evalTest.observations;
      request["number_days"] = this.evalTest.number_days;
      request["city_start"] = this.evalTest.city_start;
      request["is_agreement"] = this.evalTest.is_agreement;

      this.save(request);

    }, 

    info(){
        this.inputs = this.evaluatorData;
        this.evaluatorName = this.evaluatorData.first_name + " " +this.evaluatorData.last_name; 
    },

    correctDate(fecha) {
      fecha = new Date(fecha);
      fecha.setDate(fecha.getDate() + parseInt(1));
      return fecha;
    },

    getData(){
      this.preloader = true;
      var request = {};
      request['evalTest'] = this.evaluation.id;
      request['evaluatorId'] =  this.inputs.id;
      var url = `/accreditationtechnical/planningteam/infoEvaluationPlanification`;
      axiosPost(url, request)
      .then((data) =>{
        this.evalTest = data.data;
        if(data.data.evaluator.scope == "E"){
          this.scope = "Externo";
        }else{
          this.scope = "SAE";
        }

        if(data.data.evaluator.type_institution == "PU"){
          this.entity = this.inputs.institution+" (Pública)";
        }else{
          this.entity = this.inputs.institution+" (Privada)";
        }
        if(!this.evalTest.date_start){
          this.dateStart = this.correctDate(this.evaluation.date_start);
          this.dateEnd = this.correctDate(this.evaluation.date_end);
        }else{
          this.dateStart = this.correctDate(this.evalTest.date_start);
          this.dateEnd = this.correctDate(this.evalTest.date_end);
        }
        
        this.preloader = false;
      })
    },
    
    /**
     * $emit for confirmed opration
     */
    confirmed() {
      this.$emit("confirmed", false);
    },
    /**
     * $emit for cancelled opration
     */
    cancelled() {
      this.closed();
    },
    closed() {
      this.$emit("cancelled", false);
    },

    afterSuccess(response) {
      if (response.data.status == true) {
        this.$toastr.s(response.data.message);
        this.$hub.$emit("reload-" + this.tableId);
      } else {
        this.$toastr.e(response.data.message);
      }
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>

